import { faGaugeSimpleMax } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelPanel from '../../../components/voxel/Surfaces/VoxelPanel';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';

export interface UsagePanelProps {
  title: string;
  blocked: boolean;
  tooltip: string;
}

export const UsagePanel: React.FC<UsagePanelProps> = ({ title, children, blocked, tooltip }) => {
  return (
    <VoxelPanel paddingClass="p-6">
      <>
        <div className="flex flex-row items-center gap-2">
          {blocked && (
            <VoxelTooltipShort message="Blocked until next period">
              <FontAwesomeIcon icon={faGaugeSimpleMax} size="lg" className="text-red-400" />
            </VoxelTooltipShort>
          )}
          <VoxelText variant="title3" colorClassName={blocked ? 'text-red-500' : ''}>
            {title}
          </VoxelText>
        </div>
        <div className="w-full flex flex-col gap-1 mt-4">{children}</div>
        <div className="my-4" />
        <VoxelText className="text-[12.5px]" color="light">
          {tooltip}
        </VoxelText>
      </>
    </VoxelPanel>
  );
};

export default UsagePanel;
